export class ReviewController {
    static get $inject() {
        return [
            '$http'
        ];
    }

    constructor($http) {
        this.entryPoint = '/api/reviews';
        this.$http = $http;
        this.currentReview;
        this.getReviews();
    }

    getReviews() {
        this.$http.get(this.entryPoint).then((reviews) => {
            this.reviews = reviews.data;
            if (this.reviews && this.reviews.length > 0) {
                this.currentReview = this.reviews[0];
                this.currentReview.selected = true;
            }
        });
    }

    select(review) {
        this.currentReview.selected = false;
        this.currentReview = review;
        this.currentReview.selected = true;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/reviews/reviews.controller.js